<template>
    <div class="flexy">
        <section class="hero">
            <div class="hero-body">
                <div class="level">
                    <div class="level-left">
                        <h1 class="title">Furnizori</h1>
                    </div>
                    <div class="level-right">
                        <button class="button is-primary" @click="add">
                            <span class="icon is-small">
                                <i class="fa fa-plus-circle"></i>
                            </span>
                            <span>Adauga</span>
                        </button>
                    </div>
                </div>
                <hr class="is-hidden-mobile" />
            </div>
        </section>
        <div class="has-text-centered">
            <b-field class="is-pulled-right is-clearfix">
                <b-input
                    placeholder="nume furnizor ..."
                    type="input"
                    icon="magnify"
                    v-model="query"
                    @keyup.native.enter="search"
                ></b-input>
                <p class="control">
                    <button
                        class="button is-primary is-outlined"
                        size="is-large"
                        @click="search"
                    >
                        Cauta
                    </button>
                </p>
            </b-field>

            <div class="is-clearfix"></div>

            <loading-info />

            <div class="table-container" v-show="!isLoading">
                <b-table
                    :data="providers.items"
                    :bordered="true"
                    :striped="true"
                    :narrowed="false"
                    :hoverable="true"
                >
                    <template bordered>
                        <b-table-column
                            field="name"
                            label="Nume"
                            v-slot="props"
                        >{{ props.row.name }}</b-table-column>

                        <b-table-column field="cui" label="CUI" v-slot="props">{{
                            props.row.cui
                        }}</b-table-column>

                        <b-table-column field="address" label="Adresa" v-slot="props">{{
                            props.row.address
                        }}</b-table-column>

                        <b-table-column field="phone" label="Telefon" v-slot="props">{{
                            props.row.phone
                        }}</b-table-column>

                        <b-table-column field="email" label="Email" v-slot="props">{{
                            props.row.email
                        }}</b-table-column>

                        <b-table-column 
                            field="totalSpent" 
                            label="Total Cheltuit" 
                            v-slot="props"
                            :numeric="true"
                        >
                            <span :class="{'has-text-success': props.row.totalSpent > 0}">
                                {{ formatCurrency(props.row.totalSpent) }}
                            </span>
                        </b-table-column>

                        <b-table-column label :centered="true" width="160" v-slot="props">
                            <button
                                class="button is-small is-rounded"
                                @click="edit(props.row)"
                            >
                                <span class="icon is-small">
                                    <i class="fa fa-edit"></i>
                                </span>
                            </button>
                            <button
                                class="button is-small is-rounded"
                                @click="del(props.row)"
                            >
                                <span class="icon is-small has-text-danger">
                                    <i class="fa fa-trash"></i>
                                </span>
                            </button>
                        </b-table-column>
                    </template>
                    <template #empty>
                        <div class="has-text-centered">
                            <h1 class="is-size-5">
                                Nu am gasit nici o inregistrare.
                            </h1>
                            <div>
                                <button class="button is-text" @click="add">
                                    Adauga o inregistrare noua
                                </button>
                            </div>
                        </div>
                    </template>
                </b-table>
            </div>

            <b-pagination
                v-show="!isLoading && providersList.length > 0"
                :total="providers.total"
                :current.sync="page"
                :simple="false"
                :rounded="false"
                :per-page="providers.perPage"
                @change="doPaginate"
            >
            </b-pagination>
        </div>
    </div>
</template>

<script>
import Form from "@/components/ProviderForm";
import LoadingInfo from "@/components/LoadingInfo";

import { mapGetters, mapActions, mapState } from "vuex";

export default {
    name: "providers",
    components: { LoadingInfo },
    data() {
        return {
            page: 1,
            query: "",
        };
    },
    computed: {
        ...mapGetters(["isLoading"]),
        ...mapState(["providers"]),
        providersList() {
            return this.providers.items || [];
        },
    },

    methods: {
        ...mapActions(["loadProviders", "delProvider"]),
        formatCurrency(value) {
            if (value === null || value === undefined) return "0 RON";
            return new Intl.NumberFormat("ro-RO", {
                style: "currency",
                currency: "RON",
                minimumFractionDigits: 2,
            }).format(value);
        },
        search() {
            this.page = 1;
            this.doPaginate();
        },
        add: function () {
            this.$buefy.modal.open({
                parent: this,
                component: Form,
                hasModalCard: true,
                canCancel: false,
                props: { reload: this.doPaginate },
            });
        },
        del(f) {
            this.$buefy.dialog.confirm({
                message: `Sigur stergem furnizorul: <b> ${f.name}</b> ?`,
                onConfirm: () => {
                    this.delProvider(f.id)
                        .then(() => {
                            this.doPaginate();
                            this.$buefy.toast.open({
                                message: "Furnizor sters!",
                                type: "is-success"
                            });
                        })
                        .catch((err) => {
                            var message = "Eroare la stergerea furnizorului.";
                            if (err.response && err.response.data && err.response.data.message) {
                                message = err.response.data.message;
                            }
                            this.$buefy.dialog.alert({
                                title: "Nu se poate sterge",
                                message: message,
                                type: "is-danger",
                                hasIcon: true,
                                icon: "times-circle",
                                iconPack: "fa"
                            });
                        });
                },
            });
        },
        edit: function (f) {
            this.$buefy.modal.open({
                parent: this,
                component: Form,
                hasModalCard: true,
                canCancel: false,
                props: { providerId: f.id, reload: this.doPaginate },
            });
        },
        doPaginate(page) {
            // Verifică dacă page este un număr valid, altfel folosește 1
            if (typeof page !== 'number' || isNaN(page)) {
                page = 1;
            }
            this.loadProviders({ page: page, query: this.query });
        },
    },
    mounted() {
        this.doPaginate();
    },
};
</script>

